import {Role} from '../../identite/shared/classes/role';

export interface Content {
    body: string;
}

export class Commentaire {
    com_content: string;
    com_created_at: string;
    com_id: string;
    com_ressource_id: string;
    com_ressource_type: string;
    com_roles_id: string;

    role: Role | null;
    content: Content;

    constructor(init?: Partial<Commentaire>) {
        Object.assign(this, init);
        if (!init)
            return;
        this.role = new Role(init['role']);
        this.content = JSON.parse(init['com_content']);
    }
}
